import { createFileRoute, redirect } from "@tanstack/react-router";
import { AssetGroupPicker } from "@/components/MaintenaceHelper/AssetGroupPicker";

export const Route = createFileRoute("/_auth/strategi/vedlikeholdsveileder/")({
  beforeLoad: () => {
    if (!(import.meta.env.WAI_MAINTENANCEHELPER_ENABLED || import.meta.env.DEV)) {
      throw redirect({ to: "/" });
    }
  },
  component: AssetGroupPicker,
});
